import { BaseDataModel } from "@domain/shared/types/BaseDataModel";

export class JobReady extends BaseDataModel {
	name!: string;
	jobIds!: string[];
	submissionNotes!: string;
	priority!: string;
	submitter!: string;
}
